export default new class QRService {
    generateQRLink(room_code) {
        let link = process.env.VUE_APP_DOMAIN;
        link += 'room/' + room_code;
        return link;
    }
}